import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const CONTACT = {
  phone: "1800 953 365",
  phoneTel: "tel:1800953365",
  email: "sales@bonzabfs.com.au",
  calendly:
    "https://calendly.com/bonza-business-and-franchise-sales/sell-my-business-salon?month=2026-07",
};

export const api = axios.create({ baseURL: API });

// Attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bonza_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function aud(value) {
  const n = Number(value || 0);
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    maximumFractionDigits: 0,
  }).format(isNaN(n) ? 0 : n);
}

export function pct(value, digits = 0) {
  const n = Number(value || 0) * 100;
  return `${n.toFixed(digits)}%`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
